__turbopack_context__.v({
  "icon": "UEug9G_icon",
  "indicator": "UEug9G_indicator",
});
